import React from "react";
import {withRouter} from "react-router-dom";
import ScreenComponent from "../../components/screenComponent";
import {Button, Col, Collapse, Fade, FormControl, InputGroup, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBirthdayCake,
    faEye,
    faPassport,
    faSearch,
    faSpinner,
    faTerminal,
    faTimes,
    faUserGraduate
} from "@fortawesome/pro-solid-svg-icons";
import {Get, Post} from "../../components/request";
import DivTable from "../../components/divTable";
import Documents from "./documents";
import PAE from "./pae";
import IconTitle from "../../components/iconTitle";
import ParcoursAnterieur from "./parcoursAnterieur";
import Emploi from "./emploi";
import DownloadDocument from "../documents/download";

class Verifications extends ScreenComponent {

    state = {
        search: "",
        inscriptionID: 0,
        countSearch: 0,
        loading: false,
        results: [],
    }

    handleKeyPress = e => {
        if (e.key === 'Enter') this.search();
    }

    async search() {
        if (this.state.search === "") return;

        this.setState({
            loading: true,
            countSearch: ++this.state.countSearch
        });

        const {body} = await Get(`/v1/extranet/verifications?search=${this.state.search}`);

        if (body.length === 1) await Post(`/v1/security/matricule/${body[0].EtudiantMatricule}`);

        this.setState({
            loading: false,
            results: body,
            inscriptionID: body.length === 1 ? body[0].InscriptionID : 0
        });
    }

    async updateSearch(id) {
        let etudiant = this.state.results.find(f => f.InscriptionID === id);

        await Post(`/v1/security/matricule/${etudiant.EtudiantMatricule}`);

        setTimeout(() => this.setState({
            results: [etudiant],
            search: etudiant.EtudiantMatricule,
            inscriptionID: etudiant.InscriptionID
        }), 250);
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        document.body.classList.remove("save");
    }

    render() {
        document.body.classList.add("save");
        return (
            <section>
                {this.renderSearchbar()}
                {this.renderLoading()}
                <hr className={"mx-4 pt-4 mt-4 mb-0"}/>
                {this.renderMultiResults()}
                <hr className={"mx-4 mt-4 mb-0"}/>
                {this.renderResult()}
            </section>
        );
    }

    renderResult() {
        return <Fade in={!this.state.loading && this.state.countSearch > 0 && this.state.results.length <= 1}
                     timeout={2500}>
            <div className={"py-5"}>
                {this.state.results.length === 1
                    ?
                    <>
                        <section className={"mb-5"}>
                            <IconTitle type={"h1"} icon={faUserGraduate}
                                       content={this.state.results[0].EtudiantMatricule + " - " + this.state.results[0].Etudiant}/>
                            <Row>
                                <Col sm="auto">
                                    <IconTitle type={"h6"} classIcon={"ml-3"} icon={faTerminal}
                                               content={this.state.results[0].NiveauCoursLibelle}/>
                                </Col>
                                <Col sm="auto">
                                    <IconTitle type={"h6"} classIcon={"ml-3"} icon={faBirthdayCake}
                                               content={new Date(this.state.results[0].PersonneDateNaissance).toLocaleDateString()}/>
                                </Col>
                                <Col sm="auto">
                                    <IconTitle type={"h6"} classIcon={"ml-3"} icon={faPassport}
                                               content={this.state.results[0].PersonneNationalite}/>
                                </Col>
                            </Row>
                        </section>
                        <hr className={"m-5"}/>
                        <PAE search={this.state.inscriptionID}/>
                        <hr className={"m-5"}/>
                        <Documents matricule={this.state.results[0].EtudiantMatricule}
                                   search={this.state.inscriptionID}/>
                        <DownloadDocument isVerification={true}
                                          matricule={this.state.results[0].EtudiantMatricule}
                                          search={this.state.inscriptionID}/>
                        <hr className={"m-5"}/>
                        <ParcoursAnterieur matricule={this.state.results[0].EtudiantMatricule}
                                           search={this.state.inscriptionID}/>
                        <hr className={"m-5"}/>
                        <Emploi matricule={this.state.results[0].EtudiantMatricule} search={this.state.inscriptionID}/>
                        <hr className={"m-5"}/>
                    </>
                    : <h2 className={"text-center"}>Aucun résultat</h2>}
            </div>
        </Fade>;
    }

    renderMultiResults() {
        return <Collapse in={!this.state.loading && this.state.countSearch > 0 && this.state.results.length > 1}
                         timeout={2500}>
            <div className={""}>
                <DivTable columns={{
                    "Matricule": "EtudiantMatricule",
                    "Nom Prénom": "Etudiant",
                    "Niveau de cours": "NiveauCoursLibelle"
                }} array={this.state.results}
                          actions={[{
                              onClick: id => this.updateSearch(id),
                              icon: faEye, title: "Visualiser"
                          }]}/>
            </div>
        </Collapse>;
    }

    renderLoading() {
        return <Collapse in={this.state.loading} timeout={2500}>
            <div>
                <div className={"text-center pt-5 pb-4"}>
                    <FontAwesomeIcon icon={faSpinner} className={"fa-3x"} pulse={true}/>
                </div>
            </div>
        </Collapse>;
    }

    renderSearchbar() {
        return <InputGroup onKeyPress={this.handleKeyPress}>
            <FormControl
                autoFocus={true}
                placeholder="Matricule | Nom | Prénom"
                aria-label="Matricule | Nom | Prénom"
                value={this.state.search}
                onChange={(v) => this.setState({search: v.target.value})}
            />
            <InputGroup.Append>
                <button type="button" className="btn bg-transparent" style={{marginLeft: "-26px", zIndex: 100}}
                        onClick={() => this.setState({search: "", results: [], countSearch: 0, inscriptionID: 0})}>
                    <FontAwesomeIcon icon={faTimes}/>
                </button>
            </InputGroup.Append>
            <InputGroup.Append>
                <Button className={"px-4"} onClick={this.search.bind(this)}>
                    <FontAwesomeIcon icon={faSearch}/>
                </Button>
            </InputGroup.Append>
        </InputGroup>;
    }
}

export default withRouter(Verifications);